// extracted by mini-css-extract-plugin
export default {"statusIcon":"styles_statusIcon__F6CQI","errorIcon":"styles_errorIcon__oYaIv"};